import safeLoadLocale from '@cdo/apps/util/safeLoadLocale';

let locale = safeLoadLocale('craft_locale');
module.exports = locale;
